<template>
    <el-row class="main-box flex-column flex1">
        <el-col class="content-box-col" :sm="{ span: 22, offset: 0 }" :md="{ span: 16, offset: 3 }"
            :lg="{ span: 13, offset: 5 }" :xl="{ span: 10, offset: 7 }">
            <div v-if="getCurrentWord.word" class="content-box">
                <div class="content-box-title">{{ getCurrentWord.word }}</div>
                <div class="content-box-countdownbox">{{ activedIndex == -1 && countdownNum > 0?countdownNum : ''}}(停留时间超过10秒，建议选择不认识）</div>
                <div class="content-box-list flex-cloumn">
                    <div v-for="(item, index) in getCurrentWord.resultOption" :key="'item' + index"
                        @click="changeItem(index)"
                        :class="[activedIndex == index ? 'content-box-item-actived' : '', item == '不认识' ? 'content-box-item2' : '']"
                        class="content-box-item flex-column f-center">

                        <el-tooltip v-if="item !== '不认识'" effect="dark" :content="item" placement="top-end">
                            <div class="content-box-item-text">{{ item }}</div>
                        </el-tooltip>
                        <div v-else class="content-box-item-text">{{ item }}</div>


                    </div>
                </div>
                <div class="contetnt-box-btnsbox flex-row f-align-center">
                    <div @click="reportHandle" class="contetnt-box-bnts1 flex-row f-center">
                        <span>正确</span>
                        <span>{{ successNum }}</span>
                    </div>
                    <div class="contetnt-box-bnts2 flex-row f-center">
                        <span>错误</span>
                        <span>{{ failNum }}</span>
                    </div>
                    <span class="contetnt-box-numberbox">{{ currentWordIndex + 1 }}/{{ testWordList.length }}</span>
                </div>
            </div>
        </el-col>
		
		
		<audio   ref="audio">
			<source :src="playsrc" type="audio/mp3"/>
		</audio>
		
		<el-dialog title="" :center="true" :visible.sync="dialogConfrimStartClass" :show-close="false">
			
			    <el-row slot="title" style="width: 100%;">
			        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
			            <div class="appraise-popup-title flex-row f-justify-between f-align-center">
			                <div style="width:56px;height:56px;"></div>
			                <span class="appraise-popup-title-name">提示</span>
			                <img @click="clearWind" src="../static/close.png" alt="">
			            </div>
			        </el-col>
			    </el-row>
			    <el-row style="width: 100%;">
			        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
			            <div class="start-popup-content flex-column f-align-center">
			                <div class="start-popup-content-tipsbox flex-row f-align-center">
			                    <span>{{pupmsg}}</span>
			                </div>
			                <div class="start-popup-content-line"></div>
			                <div class="start-popup-content-btnsbox flex-row f-justify-end" style="width:100%;">
			                    <div style="cursor: pointer;" @click="clearWind">确定</div>
			                </div>
			            </div>
		
			        </el-col>
			    </el-row>
			
			</el-dialog>
    </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { Message } from 'element-ui';
import lodash from "lodash";

let timer1 = "";
let selectTimer = ""

export default {
    data() {
        return {
            activedIndex: -1,
            currentWordIndex: 0,
            testWordList: [],
            selectedTestWordList: [],
            successNum: 0,
            failNum: 0,
            countdownNum: 10,
			courseId:"",
			studentId:"",
			playsrc:"",
			opentype:"",
			cwnum:0,//连续错误次数
			gradeTestSumError:7,//总共错误次数
			gradeTestContinuousError:6,//总共连续错误次数
			dialogConfrimStartClass: false,
			pupmsg:""
        }
    },
    computed: {
        ...mapState([
            'userInfos',
            'userToken',
        ]),
        ...mapGetters(["getUserToken"]),
        getCurrentWord() {
            if (this.testWordList.length == 0) {
                return {};
            } else {
				this.requsturl(this.testWordList[this.currentWordIndex].id);
                return this.testWordList[this.currentWordIndex];
            }
        }
    },
    created() {
		this.courseId = this.$route.query.courseId;
		this.studentId=this.$route.query.studentId;
		this.opentype=this.$route.query.opentype;
		
		this.checkCondition();
        this.getvocabularyTestWordList();
    },
    beforeDestroy() {
        if (timer1) {
            clearTimeout(timer1);
            timer1 = "";
        }
    },
    mounted() {
        window.isCloseHint = true
        // 初始化关闭
        window.addEventListener('beforeunload', (e) => {

            if (window.isCloseHint) {
                let confirmationMessage = '您确定要关闭窗口吗，测试单词数据可能会丢失！';
                (e || window.event).returnValue = confirmationMessage
                return confirmationMessage
            }
        })
    },
    beforeDestroy() {
        window.isCloseHint = false;
        window.removeEventListener("beforeunload", function () {
            console.log("beforeunload remove")
        })
        if (selectTimer) {
            clearInterval(selectTimer);
            selectTimer = "";
        }
    },
    watch: {
        testWordList: {
            handler(newVal, oldVal) {
                if (this.selectedTestWordList.length == 0) {
                    selectTimer = setInterval(() => {
                        if (this.countdownNum == 0) {
                            this.changeItem(this.getCurrentWord.resultOption.length - 1);
                        } else {
                            this.countdownNum--;
                        }
                    }, 1000 * 1);
                }
            },
            deep: true,
            immediate: false
        },
        selectedTestWordList: {
            handler(newVal, oldVal) {
                if (this.selectedTestWordList.length < this.testWordList.length) {
                    selectTimer = setInterval(() => {
                        if (this.countdownNum == 0) {
                            this.changeItem(this.getCurrentWord.resultOption.length - 1)
                        } else {
                            this.countdownNum--;
                        }

                    }, 1000 * 1);

                }
            },
            deep: true,
            immediate: false
        }
    },
    methods: {
		clearWind(){
			this.$router.back();
		},
		async requsturl(id){
			if(this.isplay)
			{
				return;
			}
			this.isplay=true;
			 let res = await this.$api.get("/web/teacher/home/selectWordPronunciation", {
			        headers: { //头部参数
			            frontUserToken: this.getUserToken
			        },
					params:{
						id :id,
					 }
			    });
				this.isplay=false;
				if(res.code==200)
				{
					this.play(res.data.pronunciation);
				}
		},
		play(url)
		{
			this.playsrc=url;
			let music1 = new Audio();
			 music1 = url;
			 this.$refs.audio.src = music1;
			 let audioPlayer = this.$refs.audio;
			 audioPlayer.playbackRate = 1.2;
			this.$refs.audio.play();
		},
        changeItem: lodash.debounce(function (index) {
            if (this.activedIndex == index || this.selectedTestWordList.length == this.testWordList.length) {
                return;
            }
            if (selectTimer) {
                clearInterval(selectTimer);
                selectTimer = "";
            }

            this.activedIndex = index;
            let item = this.testWordList[this.currentWordIndex];
            this.testWordSubmit(item, index);
        },
            250,
            {
                leading: true,
                trailing: false,
            }
        ),
        reportHandle() {
          // this.$router.replace({
          //     path: "/vocabulary_testreport",
          //     query: {
               
          // 		opentype:this.opentype
          //     }
          // })
        },
        async getvocabularyTestWordList() {
            if (this.userInfos.role == "0") {

                let res = null;
                let apiUrl = "web/frontUser/student/vocabularyTestWordList";
                let params = {};
                res = await this.$api.get(apiUrl, {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params
                })

                if (res.code == 200) {
                    this.testWordList = res.data;
                } else {
                    Message({
                        type: "error",
                        message: res.msg
                    })
                }
            } else if (this.userInfos.role == "1") {

                let res = null;
                let apiUrl = "web/frontUser/teacher/vocabularyTestWordList";
                let params = {
					courseId:this.courseId,
				};
                res = await this.$api.get(apiUrl, {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params
                })

                if (res.code == 200) {
                    this.testWordList = res.data;
                } else {
                    Message({
                        type: "error",
                        message: res.msg
                    })
                }
            }
        },
		async checkCondition() {
		        let res = null;
		        let apiUrl = "/web/frontUser/teacher/checkCondition";
		        let params = {};
		        res = await this.$api.get(apiUrl, {
		            headers: { //头部参数
		                frontUserToken: this.getUserToken
		            },
		            params
		        })
		
		        if (res.code == 200) {
		            this.gradeTestContinuousError = parseInt(res.data.gradeTestContinuousError+"",10);
					 this.gradeTestSumError = parseInt(res.data.gradeTestSumError+"",10);
					 console.log("~~~~"+this.gradeTestContinuousError+"~~~~~~~~"+this.gradeTestSumError );
		        } else {
		            // Message({
		            //     type: "error",
		            //     message: res.msg
		            // })
		        }
		},
        async testWordSubmit(item, index) {
            if (this.userInfos.role == "0") {

                let tmp = {
                    id: item.id,
                    word: item.word,
                    chinese: item.chinese,
                    phonetic: item.phonetic,
                    pronunciation: item.pronunciation,
                    description: item.description,
                    studentStage: item.studentStage,
                    wordCount: item.wordCount,
                    resultOption: item.resultOption,
                    studentChinese: item.resultOption[index],
                };
            this.selectedTestWordList.push(tmp);
			var isok=false;
			
			if (item.resultOption[index] == item.chinese) {
			    this.successNum++;
				if(index==4)
				{
					if(this.cwnum>=this.gradeTestContinuousError)
					{
						isok=true;
					}else{
						this.cwnum++;
					}
				}else{
					this.cwnum=0;
				}
			} else {
			    this.failNum++;
				if(this.cwnum>=this.gradeTestContinuousError)
				{
					isok=true;
				}else{
					this.cwnum++;
				}
				
				if(this.failNum>=this.gradeTestSumError){
					isok=true;
				}
			}
		
			
			if(isok){
				for(var i=this.selectedTestWordList.length;i<this.testWordList.length;i++)
				{
					var item2=this.testWordList[i];
					var tmp1 = {
					    id: item2.id,
					    word: item2.word,
					    chinese: item2.chinese,
					    phonetic: item2.phonetic,
					    pronunciation: item2.pronunciation,
					    description: item2.description,
					    studentStage: item2.studentStage,
					    wordCount: item2.wordCount,
					    resultOption: item2.resultOption,
					    studentChinese: item2.resultOption[4],
					};
					this.selectedTestWordList.push(tmp1)
				}
			}else{
				if (this.currentWordIndex < this.testWordList.length - 1) {
				    this.currentWordIndex++;
				    timer1 = setTimeout(() => {
				        clearTimeout(timer1);
				        timer1 = "";
				        this.activedIndex = -1;
				        this.countdownNum = 10;
				    }, 200);
				}
			}
          

                if (this.selectedTestWordList.length == this.testWordList.length) {

                    let res = null;
                    let apiUrl = "web/frontUser/student/vocabularyTestAdd";
                    res = await this.$api.post(apiUrl,
                        this.selectedTestWordList,
                        {
                            headers: { //头部参数
                                frontUserToken: this.getUserToken
                            },
                        })

                    if (res.code == 200) {
                        // this.testWordList = res.data;
                        this.$router.replace({
                            path: "/vocabulary_testreport",
                            query: {
                                detail: encodeURIComponent(JSON.stringify(res.data)),
								opentype:this.opentype
                            }
                        })
                    }else if (res.code == 2222) {
						this.pupmsg=res.msg;
						this.dialogConfrimStartClass=true;
                    }else {
                        Message({
                            type: "error",
                            message: res.msg
                        })
                    }
                }



            } else if (this.userInfos.role == "1") {

                let tmp = {
                    id: item.id,
                    word: item.word,
                    chinese: item.chinese,
                    phonetic: item.phonetic,
                    pronunciation: item.pronunciation,
                    description: item.description,
                    studentStage: item.studentStage,
                    wordCount: item.wordCount,
                    resultOption: item.resultOption,
                    studentChinese: item.resultOption[index],
                };
                this.selectedTestWordList.push(tmp)
              var isok=false;
              
              if (item.resultOption[index] == item.chinese) {
                  this.successNum++;
              	if(index==4)
              	{
              		if(this.cwnum>=this.gradeTestContinuousError)
              		{
              			isok=true;
              		}else{
              			this.cwnum++;
              		}
              	}else{
              		this.cwnum=0;
              	}
              } else {
                  this.failNum++;
              	if(this.cwnum>=this.gradeTestContinuousError)
              	{
              		isok=true;
              	}else{
              		this.cwnum++;
              	}
              	
              	if(this.failNum>=this.gradeTestSumError){
              		isok=true;
              	}
              }
			  
				if(isok){
					for(var i=this.selectedTestWordList.length;i<this.testWordList.length;i++)
					{
						var item2=this.testWordList[i];
						var tmp1 = {
						    id: item2.id,
						    word: item2.word,
						    chinese: item2.chinese,
						    phonetic: item2.phonetic,
						    pronunciation: item2.pronunciation,
						    description: item2.description,
						    studentStage: item2.studentStage,
						    wordCount: item2.wordCount,
						    resultOption: item2.resultOption,
						    studentChinese: item2.resultOption[4],
						};
						this.selectedTestWordList.push(tmp1)
					}
				}else{
					if (this.currentWordIndex < this.testWordList.length - 1) {
					    this.currentWordIndex++;
					    timer1 = setTimeout(() => {
					        clearTimeout(timer1);
					        timer1 = "";
					        this.activedIndex = -1;
					        this.countdownNum = 10;
					    }, 200);
					}
				}

                if (this.selectedTestWordList.length == this.testWordList.length) {

                    let res = null;
                    let apiUrl = "web/frontUser/teacher/vocabularyTestAdd";
                    res = await this.$api.post(apiUrl, {
                        wordList: this.selectedTestWordList,
						courseId:this.courseId,
						frontUserId:this.studentId,
                    },
                        {
                            headers: { //头部参数
                                frontUserToken: this.getUserToken
                            },
                        })
                    if (res.code == 200) {
                        // this.testWordList = res.data;
                        this.$router.replace({
                            path: "/vocabulary_testreport",
                            query: {
                                detail: encodeURIComponent(JSON.stringify(res.data)),
									opentype:this.opentype
                            }
                        })
                    }else if (res.code == 2222) {
						this.pupmsg=res.msg;
						this.dialogConfrimStartClass=true;
                    }else {
                        Message({
                            type: "error",
                            message: res.msg
                        })
                    }

                }

            }



        },
        getAutoFontSize(item) {
            // let scaleNum = 1 / Math.ceil(item.length / 10);
            // return `transform: scale(${scaleNum}) `

            let scaleNum = 1 / Math.ceil(item.length / 15);
            scaleNum = Number.parseInt(scaleNum * 36)
            return `fontSize: ${scaleNum}px`

        }
    }
}
</script>

<style lang="scss" scoped>
.main-box {
    // background: #E5F3F1;

    position: relative;

    .content-box-col {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .content-box {
        margin-top: 84px;
        width: 92.865%;
        min-height: 749px;
        border-radius: 20px;
        background: #E5F3F1;
        box-sizing: border-box;
        padding: 0 90px;

        .content-box-title {
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
            margin-top: 11px;
            padding-bottom: 10px;
            font-family: Oswald;
            font-size: 45px;
            font-weight: normal;
            line-height: normal;
            text-align: center;
            letter-spacing: 0em;
            font-feature-settings: "kern" on;
            /* 绿 */
            color: #0AA26B;

        }

        .content-box-countdownbox{

            height: 24px;
            text-align: center;
            color: rgb(223, 10, 10);
        }

        .content-box-list {
            margin-top: 15px;



            .content-box-item {
                margin-bottom: 30px;
                width: 100%;
                height: 80px;
                border-radius: 100px;
                /* 纯白 */
                background: #FFFFFF;
                box-sizing: border-box;

                box-shadow: 0px 0px 10px 0px rgba(140, 199, 162, 0.2);

                font-family: Oswald;
                font-size: 36px;
                text-align: center;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 绿 */
                color: #0AA26B;

                &:hover {
                    cursor: pointer;
                }
            }

            .content-box-item-text {
                width: 100%;
                box-sizing: border-box;
                padding: 0 10px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                word-break: break-all;
            }

            .content-box-item2 {
                background: rgba($color: #000000, $alpha: 0.1);
                /* 333333 */
                color: #333333;
            }

            .content-box-item-actived {
                background: #C2EBD7;
                line-height: 72px;
                box-sizing: border-box;
                border: 4px solid #238763;

                box-shadow: inset 0px 0px 10px 2px rgba(54, 202, 130, 0.5);
            }


        }

        .contetnt-box-btnsbox {
            padding-top: 10px;

            .contetnt-box-bnts1 {
                margin-right: 35px;
                text-align: center;
                width: 208px;
                height: 60px;
                line-height: 60px;
                border-radius: 100px;

                background: rgba(10, 162, 107, 0.2);

                span {
                    &:first-child {
                        font-family: Source Han Sans CN;
                        font-size: 30px;
                        font-weight: bold;
                        line-height: normal;
                        text-align: center;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 绿 */
                        color: #0AA26B;
                        margin-right: 14px;
                    }

                    &:last-child {

                        font-family: Oswald;
                        font-size: 36px;
                        font-weight: normal;
                        line-height: normal;
                        text-align: center;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 绿 */
                        color: #0AA26B;
                    }

                }
            }

            .contetnt-box-bnts2 {
                margin-right: 47px;
                width: 207px;
                height: 60px;
                border-radius: 100px;

                background: rgba(237, 101, 101, 0.2);

                span {
                    &:first-child {

                        margin-right: 13px;
                        font-family: Source Han Sans CN;
                        font-size: 30px;
                        font-weight: bold;
                        line-height: normal;
                        text-align: center;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 红 */
                        color: #ED6565;
                    }

                    &:last-child {

                        font-family: Oswald;
                        font-size: 36px;
                        font-weight: normal;
                        line-height: normal;
                        text-align: center;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 红 */
                        color: #ED6565;
                    }


                }


            }

            .contetnt-box-numberbox {
                font-family: Oswald;
                font-size: 36px;
                font-weight: normal;
                line-height: normal;
                text-align: center;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 绿 */
                color: #0AA26B;
            }

        }


    }
	
.appraise-popup-title {
	    width: 100%;
	    height: 86px;
	    border-radius: 20px 20px 0 0;
	    background: #0AA26B;
	    box-sizing: border-box;
	    padding: 0 35px;
	
	    .appraise-popup-title-name {
	        font-family: 思源黑体;
	        font-size: 26px;
	        font-weight: bold;
	        line-height: normal;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 纯白 */
	        color: #FFFFFF;
	    }
	
	    img {
	        width: 56px;
	        height: 56px;
	    }
	}
	
	.start-popup-content {
	    background: #fff;
	    border-radius: 0 0 20px 20px;
	    box-sizing: border-box;
	    padding: 0 52px;
	
	    .start-popup-content-text1 {
	        margin-left: 173.5px;
	        margin-top: 89px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        /* 333333 */
	        color: #333333;
	    }
	
	    .start-popup-content-timebox {
	        margin-top: 30px;
	        margin-left: 173.5px;
	
	        span {
	            margin-right: 30px;
	            font-family: 思源黑体;
	            font-size: 22px;
	            font-weight: normal;
	            line-height: 30px;
	            letter-spacing: 0em;
	
	            font-feature-settings: "kern" on;
	            /* 333333 */
	            color: #333333;
	        }
	
	        div {
	            width: 195px;
	            height: 64px;
	            border-radius: 100px;
	            opacity: 1;
	
	            background: #E5F7F1;
	
	            box-sizing: border-box;
	            border: 1px solid rgba(10, 162, 107, 0.2);
	        }
	
	    }
	
	    .start-popup-content-tipsbox {
	        margin-top: 89px;
	        margin-bottom: 75px;
	        font-family: 思源黑体;
	        font-size: 22px;
	        font-weight: normal;
	        line-height: 40px;
	        letter-spacing: 0em;
	
	        font-feature-settings: "kern" on;
	        color: #333333
	    }
	
	    .start-popup-content-line {
	        margin-top: 30px;
	        width: 100%;
	        height: 0px;
	        opacity: 1;
	
	        border: 1px solid rgba(10, 162, 107, 0.2);
	    }
	
	    .start-popup-content-btnsbox {
	        margin-top: 31px;
	        margin-bottom: 30px;
	
	        div {
	            &:first-child {
	                margin-right: 20px;
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 灰 */
	                background: #ACBEB0;
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	
	            &:last-child {
	
	                width: 230px;
	                height: 64px;
	                border-radius: 100px;
	                /* 绿 */
	                background: #0AA26B;
	
	                font-family: 思源黑体;
	                font-size: 28px;
	                font-weight: bold;
	                line-height: 64px;
	                text-align: center;
	                letter-spacing: 0em;
	
	                font-feature-settings: "kern" on;
	                /* 纯白 */
	                color: #FFFFFF;
	            }
	        }
	    }
	
	}
	
	
	/deep/ .el-dialog__header {
	    border-radius: 20px 20px 0 0;
	    padding: 0;
	
	}
	
	/deep/ .el-dialog__body {
	    border-radius: 20px;
	    padding: 0;
	}
	
	/deep/ .el-dialog {
	    background: transparent;
	    border-radius: 20px;
	    box-shadow: 0 0px 0px #ccc;
	
	    @media screen and (min-width: 992px) {
	        width: 44.114%;
	    }
	
	    @media screen and (max-width: 991px) and (min-width: 768px) {
	        width: 82.395%;
	    }
	
	    @media screen and (max-width: 767px) {
	        width: 100%;
	    }
	}
}
</style>